import { VideoAdType } from '@zattoo/zapi/lib/stream/enums';
const adsInfoFromAdList = (watchResponseAdInfo, disableStartAd) => {
    return watchResponseAdInfo
        .reduce((acc, ad) => {
        switch (ad.type) {
            case VideoAdType.PAUSE:
                acc.pause = {
                    vastUrl: ad.vast_url,
                    offset: ad.offset,
                    isChannelAd: ad.is_channel_ad,
                };
                break;
            case VideoAdType.FAST_FORWARD:
                acc.fastForward = {
                    vastUrl: ad.vast_url,
                    maxDuration: ad.max_duration,
                    isChannelAd: ad.is_channel_ad,
                };
                break;
            case VideoAdType.PREROLL:
                if (!disableStartAd) {
                    acc.preroll = {
                        vastUrl: ad.vast_url,
                        isChannelAd: ad.is_channel_ad,
                    };
                }
                break;
            case VideoAdType.MIDROLL:
                acc.midroll = {
                    vastUrl: ad.vast_url,
                    isChannelAd: ad.is_channel_ad,
                };
                break;
            default:
                break;
        }
        return acc;
    }, {});
};
export const adsInfoFromWatchResponse = (watchResponseAdInfo, disableStartAd) => {
    if (!watchResponseAdInfo || !watchResponseAdInfo.length) {
        return undefined;
    }
    return adsInfoFromAdList(watchResponseAdInfo, disableStartAd);
};
